import { defineStore } from 'pinia';
import { get } from '~/utils/api';
import type { BopsResponse, AvailabilityStoreState, fetchAvailabilityParams } from './useAvailabilityStore.types';
// import MockBopsavailabilityData from '../../../mocks/bcom/bopsavailable.json';

const buildUrl = (
  productId: string,
  storeLocation: number | null,
  zipCode: number | null,
  _customerExperiment: string,
  currency: string,
  isBigTicketItemFlag: boolean,
) => {
  const pathName = `/xapi/digital/v1/product/${productId}/store/bopsavailable`;
  const params: Record<string, number | string | boolean> = {};

  if (storeLocation) params._storeLocation = storeLocation;
  if (zipCode) params.sddZipCode = zipCode;
  if (_customerExperiment) params._customerExperiment = _customerExperiment;
  if (currency) params.currency = currency;

  params.bigTicketItem = isBigTicketItemFlag;

  const queryString = Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join('&');

  return `${pathName}${queryString ? `?${queryString}` : ''}`;
};

export default defineStore('availabilityStore', {
  state: (): AvailabilityStoreState => ({
    data: {},
    isDataLoaded: false,
    isZipCodeUpdated: false,
    isStoreUpdated: false,
  }),
  actions: {
    async fetchAvailability({
      storeLocation = null,
      zipCode = null,
      productId = '',
      _customerExperiment = '',
      currency = 'USD',
      isZipCodeUpdated = false,
      isStoreUpdated = false,
      isBigTicketItemFlag = false,
    }: fetchAvailabilityParams) {
      if (!productId) {
        console.error('productId is required');
        return;
      }

      const url = buildUrl(productId, storeLocation, zipCode, _customerExperiment, currency, isBigTicketItemFlag);
      const result = await get<BopsResponse>(url);

      const bopsavailabilityData = result || { productStoreBopsAvailable: {} };

      this.data = bopsavailabilityData.productStoreBopsAvailable || {};
      // To test with mocked data
      // this.data = MockBopsavailabilityData;
      this.isDataLoaded = true;
      if (isZipCodeUpdated || isStoreUpdated) {
        this.setShippingOptionUpdateStatus({
          isZipCodeUpdated,
          isStoreUpdated,
        });
      }
    },
    setShippingOptionUpdateStatus({ isZipCodeUpdated = false, isStoreUpdated = false }) {
      this.isZipCodeUpdated = isZipCodeUpdated;
      this.isStoreUpdated = isStoreUpdated;
    },
  },
  getters: {
    zipCodeFromStore(): string {
      return this.data?.store?.address?.zipCode || '';
    },
    getLoadStatus(): boolean {
      return this.isDataLoaded;
    },
  },
});
